import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBlockQueryVariables = Types.Exact<{
  number: Types.Scalars['Int']['input'];
}>;

export type GetBlockQuery = {
  __typename?: 'Query';
  block?: {
    __typename?: 'Block';
    number: number;
    hash: string;
    timestamp: any;
    createdAt: any;
    transactionCount?: number | null;
    transactions: { __typename?: 'TransactionConnection'; totalCount: number };
  } | null;
};

export const GetBlockDocument = gql`
  query GetBlock($number: Int!) {
    block(number: $number) {
      number
      hash
      timestamp
      createdAt
      transactionCount
      transactions {
        totalCount
      }
    }
  }
`;

/**
 * __useGetBlockQuery__
 *
 * To run a query within a React component, call `useGetBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockQuery({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useGetBlockQuery(
  baseOptions: Apollo.QueryHookOptions<GetBlockQuery, GetBlockQueryVariables> &
    ({ variables: GetBlockQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBlockQuery, GetBlockQueryVariables>(
    GetBlockDocument,
    options,
  );
}
export function useGetBlockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBlockQuery,
    GetBlockQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBlockQuery, GetBlockQueryVariables>(
    GetBlockDocument,
    options,
  );
}
export function useGetBlockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlockQuery, GetBlockQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBlockQuery, GetBlockQueryVariables>(
    GetBlockDocument,
    options,
  );
}
export type GetBlockQueryHookResult = ReturnType<typeof useGetBlockQuery>;
export type GetBlockLazyQueryHookResult = ReturnType<
  typeof useGetBlockLazyQuery
>;
export type GetBlockSuspenseQueryHookResult = ReturnType<
  typeof useGetBlockSuspenseQuery
>;
export type GetBlockQueryResult = Apollo.QueryResult<
  GetBlockQuery,
  GetBlockQueryVariables
>;
